"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restart = void 0;
var restart = function restart(path) {
  var _window = window,
    location = _window.location;
  if (!path) {
    location.reload();
    return;
  }
  location.replace(path);
};
exports.restart = restart;